import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Divider from '@material-ui/core/Divider'
import Hidden from '@material-ui/core/Hidden'
import { MODAL_BOARDING_ERROR_HIBOUTIK } from 'redux/modules/modals'
import LeftHiboutikInfosComponent from './LeftHiboutikInfosComponent'
import RightHiboutikFormComponent from './RightHiboutikFormComponent'
import RightVerificationComponent from './RightVerificationComponent'

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  gridContainer: {
    padding: 10
  },
  backButton: {
    marginRight: theme.spacing.unit
  }
})

export default withStyles(styles)(
  class HiboutikAccountCreationStepComponent extends React.Component {
    static propTypes = {
      classes: PropTypes.object,
      config: PropTypes.object.isRequired,
      email: PropTypes.string.isRequired,
      goToNext: PropTypes.func.isRequired,
      onChange: PropTypes.func.isRequired,
      checkAccountAvailability: PropTypes.func.isRequired,
      createHiboutikAccount: PropTypes.func.isRequired,
      checkAccountCreation: PropTypes.func.isRequired,
      showModal: PropTypes.func.isRequired
    }
    static defaultProps = {
      config: {
        hiboutikAccount: '',
        hiboutikPassword: ''
      }
    }
    handleNextStep() {
      this.props.goToNext()
    }
    handleOnChange = (name, value) => {
      this.props.onChange(name, value)
    }
    handleCreateHiboutikAccount = () => {
      this.props
        .createHiboutikAccount(this.props.config)
        .then(res => {})
        .catch(err => {
          console.error(err)
          this.props.showModal(MODAL_BOARDING_ERROR_HIBOUTIK)
        })
    }
    renderLeftSide() {
      return <LeftHiboutikInfosComponent />
    }
    renderRightSide() {
      const { config } = this.props
      if (config.hbAccountCreated) {
        return (
          <RightVerificationComponent
            checkAccountCreation={this.props.checkAccountCreation}
            email={this.props.email}
            hiboutikAccount={config.hiboutikAccount}
            accountVerified={config.hiboutikAccountVerified}
          />
        )
      }
      return (
        <RightHiboutikFormComponent
          checkAccountAvailability={this.props.checkAccountAvailability}
          handleCreateHiboutikAccount={this.handleCreateHiboutikAccount}
          handleChange={this.handleOnChange}
          hiboutikAccountValidity={this.props.config.hiboutikAccountValidity}
          hiboutikAccount={this.props.config.hiboutikAccount}
          hiboutikPassword={this.props.config.hiboutikPassword}
          hiboutikCGS={this.props.config.hiboutikCGS}
          hbAccountCreated={this.props.config.hbAccountCreated}
        />
      )
    }
    render() {
      const { classes } = this.props
      return (
        <Grid container className={classes.root}>
          <Grid item xs={12}>
            <Grid
              container
              className={classes.gridContainer}
              alignItems="center"
              direction="row"
              justify="center">
              <Grid item xs={12} md={6}>
                {this.renderLeftSide()}
              </Grid>
              <Hidden mdUp>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
              </Hidden>
              <Grid
                item
                container
                alignItems="center"
                justify="center"
                xs={12}
                md={6}>
                {this.renderRightSide()}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Boarding/components/HiboutikAccountCreation/HiboutikAccountCreationStepComponent.js